export function getIsRealisticFlexColor(colorId: string) {
  return colorId === '71' || colorId === '70';
}
